import { render, staticRenderFns } from "./UploadPaymentBankModal.vue?vue&type=template&id=98b85628&"
import script from "./UploadPaymentBankModal.vue?vue&type=script&lang=js&"
export * from "./UploadPaymentBankModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadPaymentBankModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports